import React, { useState, useEffect } from "react";
import { trackButtonClick } from "../../services/googleSheetsService";

function FloatingButton() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            // 改為判斷視窗高度的一半，這樣在不同裝置上會比較自然
            // 當捲動超過視窗高度的一半時才顯示
            if (window.scrollY > window.innerHeight / 2) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        window.addEventListener("resize", toggleVisibility); // 視窗大小改變時也要重新判斷

        return () => {
            window.removeEventListener("scroll", toggleVisibility);
            window.removeEventListener("resize", toggleVisibility);
        };
    }, []);

    const scrollToTop = () => {
        trackButtonClick("全站-回到頂部", "Top");
        window.scrollTo({
            top: 0,
            behavior: "smooth", // 平滑滾動
        });
    };
    return (
        <div className={`floating-action-button-wrap ${isVisible ? "show" : ""}`}>
            <button type="button" onClick={scrollToTop}>
                <i className="fa-solid fa-caret-up"></i>
                TOP
            </button>
        </div>
    );
}

export default FloatingButton;
